import { type FC, type ReactNode } from 'react';
import LegacyDashboardContext, { LegacyDashboardContextProps } from './LegacyDashboardContext';

interface LegacyDashboardProviderProps {
  children?: ReactNode;
  legacyDashboardContext?: LegacyDashboardContextProps;
}

const LegacyDashboardProvider: FC<LegacyDashboardProviderProps> = ({
  children,
  legacyDashboardContext,
}) => (
  <LegacyDashboardContext.Provider value={legacyDashboardContext}>
    {children}
  </LegacyDashboardContext.Provider>
);

export default LegacyDashboardProvider;
